import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationApiModel, SyncWithPlatformResultApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class LocationsService extends CrudService<LocationApiModel, number> {
  public readonly apiUrl = 'locations';

  public syncWithPlatform(): Observable<SyncWithPlatformResultApiModel> {
    return this.http.post<SyncWithPlatformResultApiModel>(`${this.apiUrl}/sync-with-platform`, {});
  }
}
